module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-318-retro-min.124665a8.jpg";